// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__1aXJS","buttons":"PendingPaymentAlert_buttons__3iQDo"};